/**
 * Which chrome each step of the booking flow gets.
 *
 * The flow-item navigation only appears once there is a shipment to navigate
 * back to, so the early steps do without it. Processing and nearly-done are
 * full-screen: they are waiting states with nothing for the customer to do, so
 * the map and the surrounding card would only be clutter.
 *
 * Anything not listed gets the ordinary treatment.
 */
const STEP_CHROME: Record<
  string,
  { navigation: boolean; map: boolean; fullScreen: boolean }
> = {
  draft: { navigation: false, map: true, fullScreen: false },
  details: { navigation: false, map: true, fullScreen: false },
  quotes: { navigation: false, map: true, fullScreen: false },
  processing: { navigation: false, map: false, fullScreen: true },
  nearlydone: { navigation: false, map: false, fullScreen: true },
};

const DEFAULT_CHROME = { navigation: true, map: true, fullScreen: false };

export function bookShipmentChromeForStep(pathIdentifier: string) {
  return STEP_CHROME[pathIdentifier] ?? DEFAULT_CHROME;
}

// Once it's narrow the card stops being a card. It has no room to float on the
// map above it, and its border only draws a box around content that already
// fills the screen — so drop the chrome and let the form be the page. ($narrow
// comes from useWidth on the container, not a container query — containment
// would re-base the fixed-position popovers inside.)
export const cardClasses =
  "relative w-full max-w-[1218px] bg-card px-4 pt-16 pb-32 min-h-[714px] -mt-[122px] rounded-[3px] border border-border-strong";
export const narrowCardClasses =
  "relative w-full max-w-[1218px] bg-card px-0 pt-8 pb-16";
